export function splitTextWithoutRegex(text: string, searchText: string) {
    if (!searchText) return [text];

    const lowerText = text.toLowerCase();
    const lowerSearchText = searchText.toLowerCase();
    const searchLength = searchText.length;
    const result: string[] = [];
    let currentIndex = 0;

    while (currentIndex < text.length) {
        const matchIndex = lowerText.indexOf(lowerSearchText, currentIndex);

        if (matchIndex === -1) {
            result.push(text.substring(currentIndex));
            break;
        }

        if (matchIndex !== currentIndex) {
            result.push(text.substring(currentIndex, matchIndex));
        }

        result.push(text.substring(matchIndex, matchIndex + searchLength));
        currentIndex = matchIndex + searchLength;
    }

    return result;
}
